// extracted by mini-css-extract-plugin
export default {"map":"AboutMap_map__16xGg","custom_marker":"AboutMap_custom_marker__z7RVx","marker_pin":"AboutMap_marker_pin__pUlEX","avatar_container":"AboutMap_avatar_container__ItlMW"};